import React from 'react';
import { CJEvent } from '@teetsh/app/src/types/event';
import { BOLabels } from '@teetsh/app/src/types/user';
import { Informations } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody/Informations';
import { Activities } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody/Activities';
import tw from 'twin.macro';
import { CustomFieldDefinition } from 'types/customField';
import { isCJEventInformationsEmpty } from 'containers/CahierJournal/DayColumn/Seance/isCJEventInformationsEmpty';
import { isCJEventActivitiesEmpty } from 'containers/CahierJournal/DayColumn/Seance/isCJEventActivitiesEmpty';

interface Props {
  print: boolean;
  event: CJEvent;
  boLabels: BOLabels;
  condensed: boolean;
  userId: string;
  isGuest?: boolean;
  customFieldDefinitions?: CustomFieldDefinition[];
  onChange: (v: CJEvent) => void;
  className?: string;
  hidden?: boolean;
}

export function CJEventBody(props: Props) {
  const {
    condensed,
    print,
    event,
    boLabels,
    userId,
    customFieldDefinitions,
    isGuest,
    className,
    hidden,
  } = props;
  const areInformationsEmpty = isCJEventInformationsEmpty(event);
  const areActivitiesEmpty = isCJEventActivitiesEmpty(event);
  return (
    <div className={className} tw="w-full">
      <div
        css={[
          condensed &&
            !areInformationsEmpty &&
            !areActivitiesEmpty &&
            tw`grid grid-cols-12 w-full gap-2`,
          hidden && tw`hidden`,
        ]}
      >
        {!areInformationsEmpty && (
          <div css={[!areActivitiesEmpty && condensed && tw`col-span-5`]}>
            <Informations
              bo={event.bo}
              customFields={event.customFields}
              materials={event.materials}
              boLabels={boLabels}
              print={print}
              customFieldDefinitions={customFieldDefinitions || []}
              onChangeCustomField={c =>
                props.onChange({
                  ...event,
                  customFields: event.customFields.map(cf =>
                    cf.id === c.id ? c : cf,
                  ),
                })
              }
            />
          </div>
        )}
        {!areActivitiesEmpty && (
          <div css={[!areInformationsEmpty && condensed && tw`col-span-7`]}>
            <Activities
              onChange={props.onChange}
              event={event}
              boLabels={boLabels}
              print={print || !!isGuest}
              userId={userId}
            />
          </div>
        )}
      </div>
    </div>
  );
}
